import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Collapse } from "reactstrap";
import "../assets/css/--component-sidebar-modern.css";
import mainWiteLogo from "../assets/images/main-logo-white.png"

// Dashboard
import dashboardIcon from "../assets/images/dashboard.png";
import dashboardIconActive from "../assets/images/dashboard-active.png";

// Orders
import ordersIcon from "../assets/images/orders.png";
import ordersIconActive from "../assets/images/orders-active.png";

// Favorites
import favoritesIcon from "../assets/images/favorites.png";
import favoritesIconActive from "../assets/images/favorites-active.png";

// Account
import accountIcon from "../assets/images/account.png";
import accountIconActive from "../assets/images/account-active.png";

// Payment
import paymentIcon from "../assets/images/payment.png";
import paymentIconActive from "../assets/images/payment-active.png";

// Notifications
import bellIcon from "../assets/images/bell.png";
import bellIconActive from "../assets/images/bell-active.png";

// Support
import supportIcon from "../assets/images/support.png";
import supportIconActive from "../assets/images/support-active.png";

const Sidebar = () => {
    const [openMenu, setOpenMenu] = useState(null);
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);
    const history = useNavigate();
    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const location = useLocation();

    // useEffect(() => {
    //     setOpenMenu(null);
    // }, [location]);

    useEffect(() => {
        if (location.pathname.includes("/account/current-orders") || location.pathname.includes("/account/order-history")) {
            setOpenMenu("orders");
        } else if (location.pathname.includes("/account/manage") || location.pathname.includes("/account/addresses") || location.pathname.includes("/account/notifications")) {
            setOpenMenu("account");
        } else {
            setOpenMenu(null);
        }
    }, [location]);

    return (
        <section id="Sidebar-grill">
            <button
                className="mobile-burger"
                onClick={() => setShowMobileSidebar(true)}
            >
                <i className="ri-menu-line"></i>
            </button>
            <aside className={`modern-sidebar ${showMobileSidebar ? "sidebar-open" : ""}`}>
                <div className="sidebar-logo mb-5 text-center" onClick={()=>history('/')}>
                    <img src={mainWiteLogo} alt="Main's Country Store" className="logo-img" />
                </div>

                <nav className="sidebar-nav">

                    {/* Dashboard */}
                    <div className="nav-item">
                        <NavLink
                            to="/account/dashboard"
                            className={({ isActive }) => `nav-link ${isActive ? "nav-active" : ""}`}
                        >
                            {({ isActive }) => (
                                <div className="nav-left">
                                    <div className="icon-wrapper">
                                        <img src={dashboardIcon} className="nav-icon hover-img" />
                                        <img
                                            src={dashboardIconActive}
                                            className="nav-icon hover-img-active"
                                        />
                                    </div>
                                    <span>Dashboard</span>
                                </div>
                            )}
                        </NavLink>
                    </div>

                    {/* My Orders */}
                    <div className="nav-item">
                        <button
                            className={`nav-link ${openMenu === "orders" ? "nav-active" : ""}`}
                            onClick={() => toggleMenu("orders")}
                        >
                            <div className="nav-left">
                                <div className="icon-wrapper">
                                    <img src={ordersIcon} className="nav-icon hover-img" />
                                    <img
                                        src={ordersIconActive}
                                        className="nav-icon hover-img-active"
                                    />
                                </div>
                                <span>My Orders</span>
                            </div>
                            <i className={`ri-arrow-${openMenu === "orders" ? "up" : "down"}-s-line arrow-icon`}></i>
                        </button>

                        <Collapse isOpen={openMenu === "orders"} className="submenu">
                            <NavLink
                                to="/account/current-orders"
                                className={({ isActive }) => `sub-link ${isActive ? "sub-active" : ""}`}
                            >
                                Current Orders
                            </NavLink>

                            <span className="separator w-75 text-blakish"></span>

                            <NavLink
                                to="/account/order-history"
                                className={({ isActive }) => `sub-link ${isActive ? "sub-active" : ""}`}
                            >
                                Order History
                            </NavLink>
                        </Collapse>
                    </div>

                    {/* Favorites */}
                    <div className="nav-item">
                        <NavLink
                            to="/account/favorites"
                            className={({ isActive }) => `nav-link ${isActive ? "nav-active" : ""}`}
                        >
                            {({ isActive }) => (
                                <div className="nav-left">
                                    <div className="icon-wrapper">
                                        <img src={favoritesIcon} className="nav-icon hover-img" />
                                        <img
                                            src={favoritesIconActive}
                                            className="nav-icon hover-img-active"
                                        />
                                    </div>
                                    <span>Favorites</span>
                                </div>
                            )}
                        </NavLink>
                    </div>

                    {/* Account */}
                    <div className="nav-item">
                        <button
                            className={`nav-link ${openMenu === "account" ? "nav-active" : ""}`}
                            onClick={() => toggleMenu("account")}
                        >
                            <div className="nav-left">
                                <div className="icon-wrapper">
                                    <img src={accountIcon} className="nav-icon hover-img" />
                                    <img
                                        src={accountIconActive}
                                        className="nav-icon hover-img-active"
                                    />
                                </div>
                                <span>Account</span>
                            </div>
                            <i className={`ri-arrow-${openMenu === "account" ? "up" : "down"}-s-line arrow-icon`}></i>
                        </button>

                        <Collapse isOpen={openMenu === "account"} className="submenu">
                            <NavLink
                                to="/account/profile"
                                className={({ isActive }) => `sub-link ${isActive ? "sub-active" : ""}`}
                            >
                                Manage Account
                            </NavLink>

                            {/* <NavLink
                                to="/account/addresses"
                                className={({ isActive }) => `sub-link ${isActive ? "sub-active" : ""}`}
                            >
                                Manage Addresses
                            </NavLink> */}

                            <NavLink
                                to="/account/notifications"
                                className={({ isActive }) => `sub-link ${isActive ? "sub-active" : ""}`}
                            >
                                Notifications
                            </NavLink>
                        </Collapse>
                    </div>

                    {/* Payment */}
                    <div className="nav-item">
                        <NavLink
                            to="/account/payment-methods"
                            className={({ isActive }) => `nav-link ${isActive ? "nav-active" : ""}`}
                        >
                            {({ isActive }) => (
                                <div className="nav-left">
                                    <div className="icon-wrapper">
                                        <img src={paymentIcon} className="nav-icon hover-img" />
                                        <img
                                            src={paymentIconActive}
                                            className="nav-icon hover-img-active"
                                        />
                                    </div>
                                    <span>Payment Method</span>
                                </div>
                            )}
                        </NavLink>
                    </div>

                    {/* Notifications */}
                    <div className="nav-item">
                        <NavLink
                            to="/notifications-history"
                            className={({ isActive }) => `nav-link ${isActive ? "nav-active" : ""}`}
                        >
                            {({ isActive }) => (
                                <div className="nav-left">
                                    <div className="icon-wrapper">
                                        <img src={bellIcon} className="nav-icon hover-img" />
                                        <img
                                            src={bellIconActive}
                                            className="nav-icon hover-img-active"
                                        />
                                    </div>
                                    <span>Notifications</span>
                                </div>
                            )}
                        </NavLink>
                    </div>

                    {/* Support */}
                    <div className="nav-item">
                        <NavLink
                            to="/support"
                            className={({ isActive }) => `nav-link ${isActive ? "nav-active" : ""}`}
                        >
                            {({ isActive }) => (
                                <div className="nav-left">
                                    <div className="icon-wrapper">
                                        <img src={supportIcon} className="nav-icon hover-img" />
                                        <img
                                            src={supportIconActive}
                                            className="nav-icon hover-img-active"
                                        />
                                    </div>
                                    <span>Support</span>
                                </div>
                            )}
                        </NavLink>
                    </div>

                </nav>
            </aside>
                {showMobileSidebar && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setShowMobileSidebar(false)}
                    ></div>
                )}
        </section>
    );
};

export default Sidebar;
